export default __webpack_public_path__ + "static/media/joe-farr.f910caaf.jpg";